import { api } from '@/lib/api';

export interface NotificationPreference {
  id: string;
  employeeId: string;
  channel: string;
  eventType: string;
  enabled: boolean;
}

export const preferencesApi = {
  getAll: () =>
    api.get<NotificationPreference[]>('/notifications/preferences').then((r) => r.data),

  update: (data: { channel: string; eventType: string; enabled: boolean }) =>
    api.patch<NotificationPreference>('/notifications/preferences', data).then((r) => r.data),
};
